'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _synopses = require('../actions/synopses');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchSynopses),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchSynopsis),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editSynopsis),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(fetchSynopsesRequest),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchSynopsisRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(editSynopsisRequest);

function fetchSynopses(_ref) {
    var filter = _ref.filter;
    var disciplineId, response;
    return regeneratorRuntime.wrap(function fetchSynopses$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    disciplineId = filter.disciplineId;
                    _context.next = 4;
                    return (0, _effects.call)(_api.request, 'get', '/synopses?disciplineId=' + disciplineId);

                case 4:
                    response = _context.sent;
                    _context.next = 7;
                    return (0, _effects.put)(_synopses.actionCreators.fetchSynopsesSucceeded(response.data, filter));

                case 7:
                    _context.next = 13;
                    break;

                case 9:
                    _context.prev = 9;
                    _context.t0 = _context['catch'](0);
                    _context.next = 13;
                    return (0, _effects.put)(_synopses.actionCreators.fetchSynopsesFailed('Ocorreu um erro na busca de quadros'));

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 9]]);
}

function fetchSynopsis(_ref2) {
    var synopsisId = _ref2.synopsisId;
    var response;
    return regeneratorRuntime.wrap(function fetchSynopsis$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/synopses/' + synopsisId);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_synopses.actionCreators.fetchSynopsisSucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_synopses.actionCreators.fetchSynopsisFailed());

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function editSynopsis(_ref3) {
    var synopsisId = _ref3.synopsisId,
        synopsis = _ref3.synopsis,
        redirect = _ref3.redirect;
    return regeneratorRuntime.wrap(function editSynopsis$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/synopses/' + synopsisId, synopsis);

                case 3:
                    _context3.next = 5;
                    return (0, _effects.put)(_synopses.actionCreators.editSynopsisSucceeded());

                case 5:
                    if (!redirect) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context3.next = 14;
                    break;

                case 10:
                    _context3.prev = 10;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 14;
                    return (0, _effects.put)(_synopses.actionCreators.editSynopsisFailed());

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 10]]);
}

function fetchSynopsesRequest() {
    return regeneratorRuntime.wrap(function fetchSynopsesRequest$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(_synopses.actionTypes.FETCH_SYNOPSES_REQUEST, fetchSynopses);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function fetchSynopsisRequest() {
    return regeneratorRuntime.wrap(function fetchSynopsisRequest$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeLatest)(_synopses.actionTypes.FETCH_SYNOPSIS_REQUEST, fetchSynopsis);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function editSynopsisRequest() {
    return regeneratorRuntime.wrap(function editSynopsisRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_synopses.actionTypes.EDIT_SYNOPSIS_REQUEST, editSynopsis);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

exports.default = [fetchSynopsesRequest, fetchSynopsisRequest, editSynopsisRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/synopses.js
// module id = 2234
// module chunks = 0